<template lang="pug">
  div(v-click-outside="hide")
    .select-choice-modal(@click="stopPropagation")
      .select-choice-modal-title 業種を選択する
      .select-choice-modal-main.no-sidebar
        p.check-all
          label.checkbox
            input(type="checkbox" v-model="allChecked" @click="checkAll")
            span すべて
        p
          label.checkbox(v-for="industry in displayIndustries")
            input(type="checkbox" :value="industry.code" v-model="industryCodes")
            span {{ industry.name }}
        p.select-choice-modal-button
          input.button-main(type="button" value="設定する" @click="submit")
    .modal-cover
</template>

<script>
  import { mapState } from 'vuex'
  import ClickOutside from 'vue-click-outside'

  export default {
    directives: { ClickOutside },
    props: ['openIndustryModal', 'selectedIndustryCd'],
    mounted () {
      this.popupItem = this.$el
      this.displayIndustries = this.industries
    },
    data () {
      return {
        allChecked: false,
        displayIndustries: [],
        industryCodes: [],
      }
    },
    computed: {
      ...mapState({
        industries: state => state.master.industries,
      }),
    },
    watch: {
      openIndustryModal () {
        const industryCd = this.selectedIndustryCd
        this.industryCodes = industryCd.map(j => j.value)
      },
      industryCodes () {
        this.setAllCheck()
      },
    },
    methods: {
      checkAll (e) {
        const codes = this.displayIndustries.map(j => j.code)
        if (e.currentTarget.checked) {
          this.industryCodes = [...new Set(this.industryCodes.concat(codes))]
        } else {
          this.industryCodes = this.industryCodes.filter(c => !codes.includes(c))
        }
      },
      stopPropagation (e) {
        e.stopPropagation()
      },
      setAllCheck () {
        const displaySelectedCount = this.displayIndustries.filter(j =>
          this.industryCodes.includes(j.code)).length
        const displayIndustriesCount = this.displayIndustries.length
        this.allChecked =
          displayIndustriesCount !== 0 && displayIndustriesCount === displaySelectedCount
      },
      submit () {
        const industries = this.industryCodes.map(c => this.industries.find(j => j.code === c))
        const industryCodes = industries.map(j => ({ label: j.name, value: j.code }))
        this.$emit('setIndustryCodes', industryCodes)
      },
      hide () {
        this.$emit('hide')
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/IndustryModal.vue